import { Link } from '@solidjs/meta';

export function Roboto()
{
	return (<>
		<Link rel='preconnect' href='https://fonts.googleapis.com' />
		<Link rel='preconnect' href='https://fonts.gstatic.com' crossorigin='' />
		<Link href='https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100..900;1,100..900&display=swap' rel='stylesheet' />
	</>);
}

Roboto.fontFamily = '"Roboto", sans-serif';
